// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__2kQ2o","loader":"Spinner_loader__3ENkM","load8":"Spinner_load8__1FLaS","loaderText":"Spinner_loaderText__1LR-O"};